import CloseIcon from "@mui/icons-material/Close";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ControlpanelSecondaryButton,
  GrayIconButton,
} from "../../../components/StyledButton";
import { CustomDialog } from "../../../components/StyledComponents";

const STATUS_STYLE = {
  CHECK_IN: {
    color: "#009900",
    labelKey: "attendance.CHECK_IN",
  },
  CHECK_OUT: {
    color: "#1557F5",
    labelKey: "attendance.CHECK_OUT",
  },
  LEAVE: {
    color: "#FF006E",
    labelKey: "common.on-leave",
  },
};

const ShowInfoEmployeeDialog = (props) => {
  const {
    title,
    listEmployee = [],
    open,
    handleClose,
    statusType = "CHECK_IN",
  } = props;
  const { t } = useTranslation();

  const statusInfo = useMemo(() => {
    const key = String(statusType || "CHECK_IN").toUpperCase();
    const style = STATUS_STYLE[key] || STATUS_STYLE.CHECK_IN;
    return {
      text: t(style.labelKey),
      color: style.color,
    };
  }, [statusType, t]);

  const employees = Array.isArray(listEmployee) ? listEmployee : [];

  return (
    <CustomDialog
      transitionDuration={300}
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      keepMounted
    >
      <DialogTitle>
        <div className="flex justify-between">
          <div className="flex items-center gap-4">
            <p className="text-xl font-semibold">{title}</p>
          </div>
          <GrayIconButton onClick={handleClose}>
            <CloseIcon />
          </GrayIconButton>
        </div>
      </DialogTitle>

      <DialogContent className="!py-0">
        <div
          className="my-4"
          style={{
            border: "1px solid #d9d9d9",
            borderRadius: 16,
            overflow: "hidden",
            background: "#fff",
            maxHeight: 420,
            overflowY: "auto",
          }}
        >
          {employees.length === 0 ? (
            <div
              className="flex items-center justify-center"
              style={{ minHeight: 120 }}
            >
              <span className="text-gray-500">{t("common.no-data")}</span>
            </div>
          ) : (
            employees.map((employee, index) => (
              <div
                key={employee.userId || employee.email || index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px 14px",
                  borderBottom:
                    index !== employees.length - 1
                      ? "1px solid #e5e7eb"
                      : "none",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#1F2937",
                    }}
                  >
                    {employee.fullName || "-"}
                  </div>
                  <div
                    style={{
                      marginTop: 4,
                      fontSize: 12,
                      color: "#6B7280",
                    }}
                  >
                    {employee.email || employee.employeeCode || "-"}
                  </div>
                </div>

                <div
                  style={{
                    color: statusInfo.color,
                    fontWeight: 500,
                    fontSize: 14,
                    whiteSpace: "nowrap",
                    marginLeft: 12,
                  }}
                >
                  {statusInfo.text}
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <div className="flex gap-2 px-4 py-4">
          <ControlpanelSecondaryButton onClick={handleClose}>
            <p>{t("button.close")}</p>
          </ControlpanelSecondaryButton>
        </div>
      </DialogActions>
    </CustomDialog>
  );
};

export default ShowInfoEmployeeDialog;
